import { render } from "./Following.vue?vue&type=template&id=c9445610&scoped=true"
import script from "./Following.vue?vue&type=script&lang=js"
export * from "./Following.vue?vue&type=script&lang=js"

import "./Following.vue?vue&type=style&index=0&id=c9445610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9445610"]])

export default __exports__